export default "__VITE_ASSET__B8ZrvV_L__"